export default function VerifyEmailView() {
    return (
        <div>
            VerifyEmail
        </div>
    );
}